import { TextField } from '@mui/material';
import React from 'react';

const WushTextField = ({formRegistration, inputEndAdornment, inputStartAdornment, formState, textAlign, step, onEnterPress, ...props}) => {
  const isError = formState && formState.errors && formState.errors[formRegistration?.name];

  const checkForEnter = (e) => {
    if (e.key === 'Enter') {
      if (onEnterPress) {
        onEnterPress();
      }
    }
  };
  return (
    <>
      <TextField
        onKeyDown={checkForEnter}
        error={isError}
        helperText={isError ? formState.errors[formRegistration?.name].message : null}
        size="small"
        sx={{
          "&.Mui-focused fieldset": {
            border: '1px solid blue',
            borderWidth: "2px"
          },
        }}
        fullWidth
        {...props}
        inputProps={{
          sx: {
            textAlign: textAlign,
            fontSize: props.fontSize,
          },
          min: 0,
          step: step
        }}
        InputProps={{
          disableUnderline: true,
          sx: {
            boxShadow: '0px 4px 20px 10px #D3D6F126',
            background: 'white',
            border: `0px solid black`,
            color: '#234352',
          },
          min: 0,
          step: step,
          ...formRegistration,
          endAdornment: inputEndAdornment,
          startAdornment: inputStartAdornment,
        }}
      />
    </>
  );
};

export default WushTextField;